import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { UnauthorizedOngoingCall } from 'APP/main/OngoingCall/UnauthorizedOngoingCall';

import { CallDevicesPreview } from './CallDevicesPreview/CallDevicesPreview';
import { useCallPreviewDevicesPresenter } from './CallPreview.devices.presenter';
import { useCallPreviewPresenter } from './CallPreview.presenter';
import styles from './CallPreview.styles.m.css';
import { CallPreviewLoader } from './CallPreviewLoader/CallPreviewLoader';
import { WebinarInvitation } from './WebinarInvitation/WebinarInvitation';

export const CallPreview: FC = observer(() => {
  const onStartCallRef = useRef<() => Promise<void>>(null);
  const devicesPresenter = useCallPreviewDevicesPresenter();
  const presenter = useCallPreviewPresenter({ onStartCallRef, devicesPresenter });

  return (
    <div className={styles.container}>
      {presenter.ongoingCall && (
        <UnauthorizedOngoingCall
          onVideoAudioStarted={presenter.startCallRef.current || undefined}
          mainCall={presenter.ongoingCall}
        />
      )}
      {!presenter.ongoingCall && (
        <>
          {!presenter.isPreviewInitialized && <CallPreviewLoader presenter={presenter} />}
          {presenter.isShowDefaultPreview && (
            <CallDevicesPreview
              presenter={presenter}
              devicesPresenter={devicesPresenter}
            />
          )}
          {presenter.isShowWebinarPreview && <WebinarInvitation presenter={presenter} />}
        </>
      )}
    </div>
  );
});
